export function getOwnAppVersion(): string {
  const path = process.env.STATIC_ASSETS_APP_PATH || '';
  const segments = path.split('/').filter((segment) => segment.length > 0);
  return segments.length > 0 ? segments[segments.length - 1] : '';
}
